/**
 * Produces a stable, URL-safe cache key for query parameters.
 *
 * Some permission filters are sets (for example, grantee IDs and categories),
 * so their order must not create distinct cache entries for the same request.
 */
export function canonicalQueryCacheKey(params: URLSearchParams): string {
  const entries = [...params.entries()].sort(([leftKey, leftValue], [rightKey, rightValue]) => {
    const keyComparison = leftKey.localeCompare(rightKey);
    return keyComparison !== 0 ? keyComparison : leftValue.localeCompare(rightValue);
  });

  return new URLSearchParams(entries).toString();
}
